import React, { useEffect, useContext } from "react";
import { HeaderContext } from "../../HeaderContext";
import { PreviewContext } from "../../PreviewContext";
import { BrandingContext } from "../../BrandingContext"; // Import BrandingContext
import Image from "./Image";
import Logo from "./Logo";
import "./styles/Header.css";

const Header = () => {
  const { isHeaderAnimated, isHeaderExtended } = useContext(HeaderContext);
  // Preview context for overrides
  const { isPreview, logoUrl: previewLogoUrl, headerUrl: previewHeaderUrl, fontStyle: previewFontStyle } = useContext(PreviewContext);
  // Branding context for base values
  const { logoUrl: baseLogoUrl, headerUrl: baseHeaderUrl, fontStyle: baseFontStyle, isLoading } = useContext(BrandingContext);

  // Determine final values based on preview status and available overrides
  const finalLogoUrl = isPreview && previewLogoUrl ? previewLogoUrl : baseLogoUrl;
  const finalHeaderUrl = isPreview && previewHeaderUrl ? previewHeaderUrl : baseHeaderUrl;
  const finalFontStyle = isPreview && previewFontStyle ? previewFontStyle : baseFontStyle;

  // Effect for managing body overflow based on isPreview (keep this)
  useEffect(() => {
    if (isPreview) {
      // Set horizontal overflow to hidden and vertical to auto
      document.documentElement.style.setProperty('overflow-x', 'hidden', 'important');
      document.documentElement.style.setProperty('overflow-y', 'auto', 'important');
      document.body.style.setProperty('overflow-x', 'hidden', 'important');
      document.body.style.setProperty('overflow-y', 'auto', 'important');

      // Inject custom scrollbar styling for vertical scrolling
      let styleTag = document.getElementById('preview-scrollbar-style');
      if (!styleTag) {
        styleTag = document.createElement('style');
        styleTag.id = 'preview-scrollbar-style';
        styleTag.textContent = `
          ::-webkit-scrollbar {
            width: 8px;
          }
          ::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          ::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
          }
          ::-webkit-scrollbar-thumb:hover {
            background: #555;
          }
        `;
        document.head.appendChild(styleTag);
      }
      console.log("Preview mode enabled: overflow-x hidden, overflow-y auto, custom scrollbar applied");
    } else {
      // Remove overflow styling
      document.documentElement.style.removeProperty('overflow-x');
      document.documentElement.style.removeProperty('overflow-y');
      document.body.style.removeProperty('overflow-x');
      document.body.style.removeProperty('overflow-y');

      // Remove custom scrollbar styling if it exists
      let styleTag = document.getElementById('preview-scrollbar-style');
      if (styleTag) {
        styleTag.parentNode.removeChild(styleTag);
      }
      console.log("Preview mode disabled: overflow properties and custom scrollbar removed");
    }
  }, [isPreview]);

  // Optional: Show loading state or default while branding loads
  if (isLoading && !isPreview) {
      // You might want a loading indicator or return null/default header
      // For now, it will render with default values from BrandingContext
  }

  return (
    <>
      {/* Apply the gradient style to the header image container if needed, or use finalAccentColor elsewhere */}
      <Image
        className={'front-page-image' + (isHeaderAnimated ? ' animated' : '') + (isHeaderExtended ? ' extended' : ' compact')}
        src={finalHeaderUrl}
        alt="Header Image"
        placeholder="/app/images/front-page-image.png"
        // If the gradient effect is desired on the image itself or a container:
        // style={accentColorStyle} // Apply style here or to a wrapper div
      />

      <Logo
        className={'logo-image' + (isHeaderAnimated ? ' animated' : '') + (isHeaderExtended ? ' extended' : ' compact')}
        src={finalLogoUrl}
        alt="Business Logo"
        style={{ fontFamily: finalFontStyle }}
        placeholder="/app/images/logo.png"
      />
      {/* If the gradient was meant as an overlay, you might need a separate div */}
      {/* <div className="header-gradient-overlay" style={accentColorStyle}></div> */}
    </>
  );
}

export default Header;